<template>
  <v-layout row wrap fluid class="d-flex mx-auto">
    <ReportSearch @getSearchCondition="doSearch" :departmentMultiple="true" />
    <v-divider></v-divider>
    <v-flex xs12 pa-5>
      <p class="subtitle-1 primary--text font-weight-bold">รายการข้อมูลซ้ำ</p>
      <v-divider></v-divider>
    </v-flex>
    <v-flex xs12 px-5 class="d-flex flex-column flex-sm-row">
      <!--v-checkbox
        label="รออนุมัติ"
        color="primary"
        class="mt-0 ml-sm-auto mr-3"
        v-show="$vuetify.breakpoint.smAndUp"
      />
      <v-checkbox
        label="ร่าง"
        color="primary"
        class="mt-0 mr-3"
        v-show="$vuetify.breakpoint.smAndUp"
      />
      <v-checkbox
        label="เสร็จ"
        color="primary"
        class="mt-0 mr-7"
        v-show="$vuetify.breakpoint.smAndUp"
      />
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
      >
        <template v-slot:activator="{ on }">
          <v-btn
            rounded
            outlined
            color="primary"
            v-on="on"
            v-show="$vuetify.breakpoint.xsOnly"
          >
            ตัวกรอง
          </v-btn>
        </template>

        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-action>
                <v-checkbox
                  label="รออนุมัติ"
                  color="primary"
                  class="mt-0 ml-sm-auto mr-3"
                />
              </v-list-item-action>
            </v-list-item>

            <v-list-item>
              <v-list-item-action>
                <v-checkbox
                  label="ร่าง"
                  color="primary"
                  class="mt-0 mr-3"
                />
              </v-list-item-action>
            </v-list-item>

            <v-list-item>
              <v-list-item-action>
                <v-checkbox
                  label="เสร็จ"
                  color="primary"
                  class="mt-0 mr-7"
                />
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu-->
      <p class="subtitle-1 ma-0 mt-2 mt-sm-0 pt-1 normal-line-height">
        รวม {{ reportDataLength }} รายการ
      </p>
    </v-flex>
    <v-flex xs12 pa-5 pt-0>
      <v-data-table
        :headers="reportHeader"
        :items="reportData"
        :items-per-page="10"
        :footer-props="footerProps"
        no-data-text="ไม่พบข้อมูล"
        class="elevation-0 mt-0"
        :hide-default-footer="reportDataLength == 0"
        :mobile-breakpoint="0"
      >
        <template v-slot:footer.page-text="props"
          >{{ props.pageStart }} - {{ props.pageStop }} จาก {{ props.itemsLength }}</template
        >

        <template v-slot:item="props">
          <tr>
            <!--td class="pr-0">
              <v-icon
                v-if="props.item.lock"
                color="primary"
              >lock</v-icon>
              <v-icon
                v-else
                color="black"
              >lock_open</v-icon>
            </td-->
            <td class="content-data">{{ props.index + 1 }}</td>
            <td class="content-data">{{ displayData(props.item.accident_date) }}</td>
            <td class="content-data">{{ displayData(props.item.accident_time) }}</td>
            <td class="content-data">{{ displayData(props.item.route_code) }}</td>
            <td class="content-data">{{ displayData(props.item.km) }}</td>
            <td class="content-data">{{ displayData(props.item.department) }}</td>
            <td class="content-data">{{ displayData(props.item.checked) }}</td>
            <td>
              <v-icon v-if="props.item.lock" color="grey">insert_drive_file</v-icon>
              <v-icon v-else color="primary" @click="goToEditPage(props.item.id)"
                >insert_drive_file</v-icon
              >
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import ReportSearch from '../report/Search';

export default {
  name: 'DuplicateReport',
  components: {
    ReportSearch
  },
  data: () => ({
    menu: false,
    footerProps: {
      // itemsPerPageOptions: [5, 10, 25, { text: 'ทั้งหมด', value: -1 }],
      itemsPerPageOptions: [],
      itemsPerPageText: 'จำนวนแถวที่แสดง',
      disableItemsPerPage: true
    },
    reportHeader: [
      /* {
        text: ' ',
        value: 'lock'
      }, */
      { text: 'ลำดับ ', align: 'center', sortable: false, value: 'no' },
      {
        text: 'วันที่',
        align: 'center',
        sortable: false,
        value: 'accident_date'
      },
      {
        text: 'เวลา',
        align: 'center',
        sortable: false,
        value: 'accident_time'
      },
      { text: 'สายทาง ', align: 'center', sortable: false, value: 'road' },
      { text: 'กม.', align: 'center', sortable: false, value: 'km' },
      {
        text: 'หน่วยงาน.',
        align: 'center',
        sortable: false,
        value: 'department'
      },
      {
        text: 'การตรวจสอบ',
        align: 'center',
        sortable: false,
        value: 'checked'
      },
      // { text: 'สถานะ', align: 'center', sortable: false, value: 'status' },
      {
        text: ' ',
        sortable: false,
        value: 'link'
      }
    ],
    reportData: []
  }),
  mounted() {
    // this.getReportData();
  },
  methods: {
    getReportData() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/duplicate/accident_by_search?`;

      // if (this.departmentSearch) {
      //   url += `depertment=${this.departmentSearch[0].id}&`;
      // }

      this.reportData = [];

      this.axios
        .get(url, {
          // params: scope.getSearchConditionParams()
        })
        .then(response => {
          if (response.status === 200) {
            scope.reportData = response.data.data;

            scope.reportData = scope.reportData.map(item => {
              item.lock = false;
              item.checked = item.checked ? 'เสร็จสิ้น' : 'ยังไม่แก้ไข';
              return item;
            });
          }
        })
        .catch(function(error) {
          // scope.reportData = [];
          scope.reportData = [];
          const { response } = error;
          if (response.status === 401 || response.status === 403) {
            scope.$router.push({ name: 'unauthorized' });
          } else {
            console.log(error);
          }
        });
    },
    displayData(data) {
      if (data) return data;
      return '-';
    },
    goToEditPage(id) {
      const routeData = this.$router.resolve({
        name: 'duplicate_detail',
        query: { data: id }
      });
      window.open(routeData.href, '_blank');
    },
    doSearch(searchObj) {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/duplicate/accident_by_search?`;
      this.axios
        .get(url, {
          params: searchObj
        })
        .then(response => {
          if (response.status === 200) {
            this.reportData = response.data.data;
            this.reportData = this.reportData.map(item => {
              item.lock = false;
              item.checked = item.checked ? 'เสร็จสิ้น' : 'ยังไม่แก้ไข';
              return item;
            });
          }
        })
        .catch(function(error) {
          const { response } = error;
          if (response.status === 401 || response.status === 403) {
            scope.$router.push({ name: 'unauthorized' });
          } else {
            console.log(error);
          }
        });
    }
  },
  computed: {
    reportDataLength() {
      return this.reportData.length;
    }
  }
};
</script>
<style lang="scss" scoped>
.normal-line-height {
  line-height: normal !important;
}
.content-data {
  width: max-content;
  white-space: nowrap;
  text-align: center;
}

tr,
td {
  border: 0 !important;
}
</style>
